import React, { useContext } from 'react'
import { ReactComponent as Scope } from '../../../assets/icons/scope.svg'
import { ReactComponent as Projects } from '../../../assets/icons/projects.svg'
import { ReactComponent as Timelines } from '../../../assets/icons/timelines.svg'
import { ReactComponent as Models } from '../../../assets/icons/models.svg'
import { FormattedMessage } from 'react-intl'
import { ContentGrid } from '../../../partials/ContentGrid'
import PartnerWithUsBlock from './PartnerWithUsBlock'
import SectionWithTag from '../../../components/SectionWithTag'
import FadeIn from '../../../components/Animation/FadeIn'
import PaddingContext from '../../../utils/PaddingContext'

const id = 'page.partnerships.partnerWithUs'

const data = [
    {
        id: 'scope',
        Icon: <Scope />,
    },
    {
        id: 'timelines',
        Icon: <Timelines />,
    },
    {
        id: 'models',
        Icon: <Models />,
    },
    {
        id: 'projects',
        Icon: <Projects />,
    },
]

const PartnerWithUs = () => {
    const { padding } = useContext(PaddingContext)
    return (
        <div className='bg-white relative border-t border-black/10 pt-12 md:p-0'>
            <div className='md:pt-30 relative'>
                <SectionWithTag
                    tag={{ id: `${id}.tag` }}
                    className='3xl:max-w-screen-2xl mx-auto'
                    padding={padding}
                >
                    <div className='max-w-[850px] mx-auto flex items-center py-10 md:p-0 text-center md:text-left'>
                        <FormattedMessage id={id} tagName='h2' />
                    </div>
                </SectionWithTag>
                <FadeIn>
                    <div className='side-padding xl:w-max mx-auto text-center'>
                        <ContentGrid className='border-t border-black/10 text-left md:mt-20'>
                            {data.map(({ id, Icon }) => (
                                <PartnerWithUsBlock id={id} Icon={Icon} key={id} />
                            ))}
                        </ContentGrid>
                    </div>
                </FadeIn>
            </div>
        </div>
    )
}

export default PartnerWithUs
